import tippy from 'tippy.js';

(function($) {
    $(document).gp_ready(function (){
        tippy('[data-tooltip]', {
            content: (reference) => reference.getAttribute('data-tooltip'),
            theme: 'tooltip',
            maxWidth: 450,
            placement: 'top-start',
            interactive: true,
            duration: [200, 200],
        });
    })
})(jQuery);